'use client';

import {default as Image} from '@/components/global/images/resized-cdn-image';
import { useState } from 'react';

import ToastSuccess from '@/components/global/toasts/toast-success';

import { doTranslation } from '@/app/i18n/client';
import copy from '@/public/assets/images/global/bus-station/copy.svg';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  address: string;
  lng: string;
}

export const CopyToClipboard = (props: Props) => {
  const { t } = doTranslation(props.lng);
  const [showToast, setShowToast] = useState(false);

  return (
    <>
      <Image
        alt={t('Copy')}
        height="24"
        onClick={() => {
          navigator.clipboard.writeText(t(props.address));
          setShowToast(true);
        }}
        src={copy}
        width="24"
      />
      {showToast && (
        <ToastSuccess
          title={t('Copy Success')}
          description={t('Address copied to clipboard')}
          onClose={() => {
            setShowToast(false);
          }}
        />
      )}
    </>
  );
};
